import React, { useState, useEffect } from 'react';
import { fetchAuth } from '../../utils/api';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

function BillingView({ user, handleApiError, showNotification }) {
    const [companyDetails, setCompanyDetails] = useState(null);
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    useEffect(() => {
        fetchAuth(`${API_URL}/api/company/details`)
            .then(res => res.ok ? res.json() : null)
            .then(setCompanyDetails);
    }, []);

    const plans = [
        { name: 'Basic', duration: '3 Months', price: '₹7,499' },
        { name: 'Standard', duration: '6 Months', price: '₹10,499' },
        { name: 'Premium', duration: '1 Year', price: '₹17,499' }
    ];

    const handlePayNowClick = (plan) => {
        setSelectedPlan(plan);
        setIsPaymentModalOpen(true);
    };

    const PaymentModal = ({ plan, onClose }) => (
        <div className="modal-overlay">
            <div className="modal-content payment-modal">
                <h3>Complete Your Payment</h3>
                <p>To activate your <strong>{plan.name} Plan</strong>, please scan the QR code below and pay <strong>{plan.price}</strong>.</p>
                <img src="/assets/payment-qr.jpeg" alt="Payment QR Code" className="qr-code-img" />
                <p className="payment-note">After payment, please allow up to 24 hours for your plan to be activated manually by our team.</p>
                <div className="modal-actions">
                    <button type="button" className="confirm-btn" onClick={onClose}>Done</button>
                </div>
            </div>
        </div>
    );

    if (!companyDetails) return <div>Loading plan details...</div>;

    return (
        <div className="page-container">
            {isPaymentModalOpen && <PaymentModal plan={selectedPlan} onClose={() => setIsPaymentModalOpen(false)} />}

            <div className="page-header">
                <h2 className="page-title">My Plan & Billing</h2>
            </div>

            <div className="billing-layout">
                <div className="plan-card">
                    <h3>Current Plan</h3>
                    <p className="current-plan-name">{companyDetails.subscriptionPlan}</p>
                    <p className="plan-expiry">
                        {companyDetails.planEndDate ?
                            `Your plan is valid until ${new Date(companyDetails.planEndDate).toLocaleDateString()}` :
                            "You are currently on a free plan."
                        }
                    </p>
                </div>

                <div className="plan-card">
                    <h3>Upgrade or Renew Your Plan</h3>
                    <table className="pricing-table">
                        <tbody>
                            {plans.map(plan => (
                                <tr key={plan.name}>
                                    <td><strong>{plan.name}</strong><br />({plan.duration})</td>
                                    <td>{plan.price}</td>
                                    <td>
                                        <button className="btn-primary" onClick={() => handlePayNowClick(plan)}>
                                            <svg className="button-icon" viewBox="0 0 24 24"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"></path></svg>
                                            Pay Now
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default BillingView;
